import { useAuth0 } from "@auth0/auth0-react";
import styles from "./keyfobs.module.css";
import Loader from "../../../components/Loader";
import KeyfobFilter from "./components/KeyfobFilter";
import KeyfobCard from "./components/KeyfobCard";
import { Helmet } from "react-helmet";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Home, X } from "react-feather";
import { useEffect, useRef, useState } from "react";
import Footer from "../../../components/Footer";
import { TableLoader } from "../../../components/LoaderC";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import AddLockKeyFobForm from "../AddComponent/AddLockKeyFobForm";
import KeyfobListMobile from "./components/KeyfobListMobile";
import { JobContext } from "../../../context/JobContext";
import { useContext } from "react";
import withCustomAuthenticationRequired from "../../../auth/withCustomAuthenticationRequired";

const Keyfobs = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteCardNumber, setDeleteCardNumber] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", type: "" });
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [keyfobList, setKeyfobList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loadError, setLoadError] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const [reloadKey, setReloadKey] = useState(0);
    const [showAddFormKeyFob, setShowAddFormKeyFob] = useState(false);
    const latestRequest = useRef(0);

    const { setJobId, setProgress, setJobData } = useContext(JobContext);

    // Debounce search so we don't hit the API on every keystroke
    useEffect(() => {
        const timer = setTimeout(() => setSearchKey(filterData.searchKey), filterData.searchKey ? 400 : 0);
        return () => clearTimeout(timer);
    }, [filterData.searchKey]);

    useEffect(() => {
        const requestId = ++latestRequest.current;

        const fetchKeyFobs = async () => {
            try {
                const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

                const response = await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs/paginated", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        page: page + 1,
                        per_page: perPage,
                        search: searchKey || undefined,
                        property_id: filterData.property !== "" ? filterData.property : undefined,
                        type: filterData.type || undefined,
                    },
                });

                // Ignore responses from requests that were superseded by newer filters/pages
                if (requestId !== latestRequest.current) return;

                setKeyfobList(response.data?.data || []);
                setTotalCount(response.data?.pagination?.total || 0);
                setLoadError(false);
            } catch (error) {
                if (requestId !== latestRequest.current) return;
                console.error('[Keyfobs] Failed to load keyfob list', error);
                setLoadError(true);
                toast.error(error?.response?.data?.message || 'Unable to load keyfobs. Please try again.');
            } finally {
                if (requestId === latestRequest.current)
                    setContentLoading(false);
            }
        };
        fetchKeyFobs();
    }, [getAccessTokenSilently, page, perPage, searchKey, filterData.property, filterData.type, reloadKey]);

    const confirmDelete = async () => {
        setDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs-new/' + deleteCardNumber, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);

            setJobId(response?.data?.data?.id);
            setProgress(0);
            setJobData(response?.data?.data);

            /*setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setFeyfobAllList(prev => {
                return prev?.filter(i => i?.card_number !== deleteCardNumber);
            });

            setDeleteCardNumber("");*/
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }


    const onKeyFobAdd = (data) => {
        // Reload from the server so the new keyfob lands on the correct page and the total stays accurate
        if (data.length > 0)
            setReloadKey(prev => prev + 1);
    }

    const renderPagination = () => (<TablePagination
        count={totalCount}
        color="primary"
        page={page}
        rowsPerPage={perPage}
        onPageChange={(e, v) => setPage(v)}
        rowsPerPageOptions={[
            { label: "4", value: 4 },
            { label: "8", value: 8 },
            { label: "16", value: 16 },
            { label: "50", value: 50 },
        ]}
        onRowsPerPageChange={(e) => {
            setPage(0);
            setPerPage(e.target.value);
        }}
        labelRowsPerPage={"Keyfobs per Page:"}
    />);

    const renderEmpty = () => (loadError ? (<div className={`${styles.NoDataMain}`}>
        <p className={`${styles.NoDataText}`}>Something went wrong</p>
        <p className={`${styles.NoDataTextSub}`}>We couldn't load keyfobs. Please refresh the page to try again.</p>
    </div>) : (<div className={`${styles.NoDataMain}`}>
        <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-keyfob.png" alt="No Data" />
        </div>
        <p className={`${styles.NoDataText}`}>Let's fill it up!</p>
        <p className={`${styles.NoDataTextSub}`}>Keyfob List is Currently Empty.</p>
    </div>));

    return <>
        {loading && <Loader />}

        <Helmet title="Manage KeyFob" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Manage Keyfob</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Smart Device</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage Keyfob</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && (<div className="Loader TableLoader">
                        <TableLoader />
                    </div>)}

                    {!contentLoading && (<div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <KeyfobFilter filterData={filterData} setFilterData={setFilterData.bind(this)} setShowAddFormKeyFob={setShowAddFormKeyFob.bind(this)} setPage={setPage.bind(this)} />

                            <div className={`${styles.NotesRow}`}>

                                {keyfobList.map((item) => {
                                    return (<KeyfobCard key={item?.card_number} item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardNumber={setDeleteCardNumber.bind(this)} setFeyfobList={setKeyfobList.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setLoading={setLoading.bind(this)} />);
                                })}

                                {keyfobList.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    {renderPagination()}
                                </div>)}

                                {keyfobList.length === 0 && renderEmpty()}

                            </div>

                            <div className={`${styles.ListMobileView}`}>
                                {keyfobList.map((item) => {
                                    return (<KeyfobListMobile key={item?.card_number} item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardNumber={setDeleteCardNumber.bind(this)} />);
                                })}

                                {keyfobList.length > 0 && (<div className={`${styles.MobilePagination} Pagination TablePaginationNew List`}>
                                    {renderPagination()}
                                </div>)}

                                {keyfobList.length === 0 && renderEmpty()}
                            </div>

                        </div>
                    </div>)}
                </div>
            </div>
        </div>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this keyfob?
                <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The keyfob information will be removed immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={showAddFormKeyFob}
            onClose={(e) => {
                setShowAddFormKeyFob(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <AddLockKeyFobForm
                setShowAddFormKeyFob={setShowAddFormKeyFob.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                onSubmitLocal={onKeyFobAdd.bind(this)}
            />
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>
}

export default withCustomAuthenticationRequired(Keyfobs, {
    onRedirecting: () => <Loader />,
});